import { CreateInstance } from "./config"
const LoginStatusCheckAPI = CreateInstance("temp_envcheck")
export default LoginStatusCheckAPI
